import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/contexts/auth-context';

/**
 * Guard pour le formulaire de login/register.
 * Redirige vers /dashboard si l'utilisateur est déjà connecté.
 *
 * Note: Ce guard est utilisé dans le composant Welcome pour le formulaire de login,
 * pas sur la route / elle-même (qui reste accessible pour afficher la landing page).
 */
export function RequireGuest({ children }) {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
